module.exports = __webpack_public_path__ + "img/atlas_img.28c681dd.png";